import React, {Component, Fragment } from 'react';

class FeeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
  	const { city } = this.props;
    return(

      <Fragment>
      	<div className='feetable__content--container'>
      		<span className='damages__title--container'>
              <h3><strong>Fee Table</strong></h3> 
            </span>
            <br/>
      		<table className='feetable__table'>
      			<thead className='feetable__header'>
      				<th><strong>Description</strong></th>
      				<th><strong>Fee</strong></th>
      			</thead>
      			<tbody className='feetable__body'>
      				<tr>
      					<td>Gas Shortage</td>
      					<td>See <a href='#gaslevel'>Gas Shortages</a></td>
      				</tr>
      				<tr>
      					<td>Returning Vehicle Late</td>
      					<td>See <a href='#latereturn'>Late Return</a></td>
      				</tr>
      				<tr>
      					<td>Damage to vehicle</td>
      					<td>See <a href='#damages'>Damages</a></td>
      				</tr>
      				<tr>
      					<td>Intentionally removing any decals/stickers</td>
      					<td>$100</td>
      				</tr>
      				<tr>
      					<td>Leaving lockbox unlocked with key inside</td>
      					<td>$100</td>
      				</tr>
      				{city === 'new_york' ? null : (<tr>
      					<td>Incorrect use of plate in Uber Driver app</td>
      					<td>$15</td>
      				</tr>)}
      				<tr>
      					<td>Tire replacement fee</td>
      					<td>$200</td>
      				</tr>
      				<tr>
      					<td>Smoking cleaning fee</td>
      					<td>$250</td>
      				</tr>
      				<tr>
      					<td>Insurance deductible</td>
      					{city === 'new_york' ? (<td>Maximum $1,500</td>):(<td>Maximum $1,000</td>)}
      				</tr>
      			</tbody>
      		</table>
      		<br/>
      		<br/>
      	</div>
        
      </Fragment>

    )
  }
 }

export default FeeTable;


// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/FeeTable.js